import axiosClient from "../lib/api/axiosClient";
const endpoint_two = process.env.REACT_APP_API_ENDPOINT_TWO;
const api_version = process.env.REACT_APP_API_VERSION;

const dashboardApi = {
  getDashboardCount: (token, departmentId, schoolId) => {
    return axiosClient.get(
      `${endpoint_two}/api/v${api_version}/Dashboard/GetDashboardCount?SchoolId=${schoolId}&DepartmentId=${departmentId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getFeedbacks: (token, SearchText, PageSize, PageNumber, schoolId) => {
    return axiosClient.get(
      `${endpoint_two}/api/v${api_version}/Dashboard/FeedBack-Complaints?SearchText=${SearchText}&PageSize=${PageSize}&PageNumber=${PageNumber}&SchoolId=${schoolId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getFeedbacksResponse: (token,  ticketId) => {
    return axiosClient.get(
      `${endpoint_two}/api/v${api_version}/Dashboard/FeedBack-responses?ticketId=${ticketId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  replyFeedback: (token, formData) => {
    return axiosClient.post(
      `${endpoint_two}/api/v${api_version}/Dashboard/Reply-Feedback`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
};

export default dashboardApi;